module.exports = __webpack_public_path__ + "img/logo_horizontal_white.ab63b63d.png";